import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=0d16992a&scoped=true&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=0d16992a&lang=scss&scoped=true&"
import style1 from "./PieChart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16992a",
  null
  
)

export default component.exports